import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Accordion, LinkIcon } from '@tkww/the-bash-frontend';
import { gmConfig } from 'helpers/config';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('lg')]: {
    ':hover': {
      '& .MuiBox-root': {
        display: 'flex',
      },
    },
  },
  '& .MuiBox-root': {
    display: 'none',
  },
}));

const FaqGroup = ({ faqCategory, faqGroup, onCopy, onAccordionChange, defaultQuestion }) => {
  const { slug, group, faqEntries } = faqGroup;

  const onCopyFaqGroupClick = async () => {
    const url = `https://${gmConfig.domains.www}/help?group=${slug}`;
    await navigator.clipboard.writeText(url);
    onCopy();
  };

  const onCopyFaqClick = async (event, faqSlug) => {
    event.stopPropagation();
    event.preventDefault();
    const url = `https://${gmConfig.domains.www}/help?question=${faqSlug}`;
    await navigator.clipboard.writeText(url);
    onCopy();
  };

  return (
    <Box sx={{ marginBottom: '56px' }}>
      <StyledTitle variant="h3" component="h2" id={`group-${slug}`}>
        {group}
        <Box onClick={onCopyFaqGroupClick} sx={{ marginLeft: '8px', height: '28px' }}>
          <LinkIcon color="blue" lazyLoad={false} />
        </Box>
      </StyledTitle>
      {faqEntries.map((faqEntry) => (
        <Accordion
          key={faqEntry.id}
          id={`question-${faqEntry.slug}`}
          data-testid={`question-${faqEntry.slug}`}
          defaultExpanded={faqEntry.slug === defaultQuestion}
          /* eslint-disable-next-line react/no-danger */
          details={<p dangerouslySetInnerHTML={{ __html: faqEntry.answer }} />}
          summary={faqEntry.question}
          onCopy={(e) => onCopyFaqClick(e, faqEntry.slug)}
          handleOnChange={onAccordionChange(faqCategory, group, faqEntry.question)}
        />
      ))}
    </Box>
  );
};

FaqGroup.propTypes = {
  faqCategory: PropTypes.string.isRequired,
  faqGroup: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    faqEntries: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
        question: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  onCopy: PropTypes.func,
  onAccordionChange: PropTypes.func,
  defaultQuestion: PropTypes.string,
};

FaqGroup.defaultProps = {
  onCopy: () => {},
  onAccordionChange: () => {},
  defaultQuestion: null,
};

export default FaqGroup;
